import { createApp } from 'vue'
import Tanjant from './Tanjant.vue'
import './assets/global.css'

createApp(Tanjant).mount('#tanjant')
